// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-star-rating-star[data-v-5d61ae9c]{overflow:visible!important}.vue-star-rating-star-rotate[data-v-5d61ae9c]{transition:all .25s}.vue-star-rating-star-rotate[data-v-5d61ae9c]:hover{transform:rotate(-15deg) scale(1.3);transition:transform .25s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
